<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3">Fulfillment Process</h3>
      <iframe
        :src="pdf_to_print"
        id="myFrame"
        frameborder="0"
        style="display: none;"
        width="300"
        height="300"
      >
      </iframe>

      <!-- <b-button
        class="mt-2 btn-action"
        variant="info"
        size="lg"
        @click="printWaybillTest_1()"
        >printWaybillTest_GOLS</b-button
      >

      <b-button
        class="mt-2 btn-action"
        variant="info"
        size="lg"
        @click="printWaybillTest_2()"
        >printWaybillTest_711</b-button
      >

      <b-button
        class="mt-2 btn-action"
        variant="info"
        size="lg"
        @click="printWaybillTest_3()"
        >printWaybillTest_SF</b-button
      > -->

      <!-- <b-button
        class="mt-2 btn-action"
        variant="info"
        size="lg"
        @click="printWaybillTest_4()"
        >printWaybillTest_4</b-button
      > -->

      <!-- <b-button
        class="mt-2 btn-action"
        variant="info"
        size="lg"
        @click="printWaybillTest_5()"
        >printWaybillTest_5</b-button
      >
      <b-button
        class="mt-2 btn-action"
        variant="info"
        size="lg"
        @click="printWaybillTest_6()"
        >printWaybillTest_6</b-button
      >

      <b-button
        class="mt-2 btn-action"
        variant="info"
        size="lg"
        @click="printWaybillTest_7()"
        >printWaybillTest_7</b-button
      > -->

      <hr />

      <b-card class="mb-1">
        <div style="width: 70%">
          <!-- <b-row nogutter>
          <b-col cols="1">
            <strong>Mode</strong>
          </b-col>
          <b-col>
            <b-form-group class="mb-0">
              <b-form-radio-group
                v-model="process_mode"
                :options="process_mode_options"
                name="radio-inline"
                size="sm"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row> -->
          <b-row>
            <b-col cols="2">
              <strong>Tracking #</strong>
            </b-col>
            <b-col cols="3">
              <b-form-input
                ref="txt_order_number"
                size="sm"
                type="text"
                placeholder
                v-model="order_master_search.order_number"
                v-on:keyup.enter="searchOrder()"
              ></b-form-input>
            </b-col>

            <b-col>
              <b-form-checkbox
                id="checkbox-packed_by_vendor"
                v-model="fulfil_obj.packed_by_vendor"
                name="checkbox-packed_by_vendor"
                value="1"
                :unchecked-value="null"
              >
                Packed by Vendor
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col class="col-2">
              <strong>Courier:</strong>
            </b-col>
            <b-col class="col-2">
              <span v-if="tracking_obj">{{
                tracking_obj.courier_short_name
              }}</span>
              <span v-if="!order_master">-</span>
            </b-col>

            <b-col class="col-2">
              <strong>Client:</strong>
            </b-col>
            <b-col class="col-2">
              <span v-if="tracking_obj">{{ tracking_obj.client_name }}</span>
              <span v-if="!order_master">-</span>
            </b-col>
          </b-row>
          <hr />
          <!-- </b-card>
      <b-card class="mt-1"> -->
          <div v-if="fulfil_obj.packed_by_vendor == null">
              <b-row class="mt-2">
                <!-- <b-col cols="2" class="pr-1">
                <strong></strong>
              </b-col> -->

              <b-col cols="3" class="pl-0 pr-1">
                <strong>Product SKU</strong>
              </b-col>

              <b-col cols="2" class="pl-0 pr-1">
                <strong>Quantity</strong>
              </b-col>

              <b-col class="pl-0 pr-1">
                <strong>Description</strong>
              </b-col>
            </b-row>

            <b-row
              class="mt-2"
              :key="row_product_i"
              v-for="(row_product, row_product_i) in fulfil_products"
            >
              <!-- <b-col cols="2" class="pr-1">
                <b-button
                    class="btn-block"
                    style="height: 100%"
                    :variant="(row_product.inputType === 'Barcode' || row_product.photo || true) ? 'success' : 'danger'"
                    size="lg"
                    @click="onOpenTakePhotoModal(row_product_i)"
                    ></b-button
                >
              </b-col> -->

              <b-col cols="3" class="pl-0 pr-1">
                <b-form-input
                  size="sm"
                  :ref="'txt_product_sku_' + row_product_i"
                  :id="'txt_product_sku_' + row_product_i"
                  type="text"
                  placeholder="Product SKU"
                  :disabled="disable_form"
                  v-model="row_product.product_sku"
                  v-on:keyup.enter="validateRowInfo(row_product, row_product_i)"
                  :state="checkProductRowSKUState(row_product)"
                ></b-form-input>
              </b-col>

              <!-- @keydown="onKeyDown($event, row_product_i)" -->

              <b-col cols="2" class="pl-0 pr-1">
                <b-form-input
                  :ref="'txt_quantity_' + row_product_i"
                  size="sm"
                  :id="'txt_quantity_' + row_product_i"
                  type="text"
                  placeholder="Quantity"
                  v-model="row_product.product_qty"
                  :readonly="!row_product.unlock_qty"
                  @click="unlockQtyInput(row_product, row_product_i)"
                  :state="checkProductRowQtyState(row_product, row_product_i)"
                ></b-form-input>
              </b-col>

              <b-col class="pl-0 pr-1">
                <b-form-input
                  size="sm"
                  :id="'txt_description_' + row_product_i"
                  type="text"
                  placeholder="Description"
                  v-model="row_product.product_description"
                  disabled
                ></b-form-input>
              </b-col>
            </b-row>
          </div>

          <div v-if="fulfil_obj.packed_by_vendor != null">
            <b-row
              class="mt-2"
              :key="row_order_i"
              v-for="(row_order, row_order_i) in fulfil_orders"
            >
              <b-col cols="3" class="pr-1">
                <b-form-input
                  size="sm"
                  :ref="'txt_order_number_' + row_order_i"
                  :id="'txt_order_number_' + row_order_i"
                  type="text"
                  placeholder="Order #"
                  v-model="row_order.order_number"
                  v-on:keyup.enter="validateRowInfo(row_order, row_order_i)"
                  :state="checkOrderRowState(row_order, row_order_i)"
                ></b-form-input>
              </b-col>

              <b-col cols="3" class="pr-1">
                <b-form-input
                  size="sm"
                  :ref="'txt_order_cartons_' + row_order_i"
                  :id="'txt_order_cartons_' + row_order_i"
                  type="text"
                  placeholder="Cartons"
                  v-model="row_order.order_cartons"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card>

      <b-card class="mt-1 mb-1">
        <b-row class="mb-3" v-if="fulfil_obj.packed_by_vendor == null">
          <b-col cols="2">
            <strong>Item Count</strong>
          </b-col>
          <b-col cols="1" class="center_align">{{
            fulfil_obj.actual_total_item_qty
          }}</b-col>
          <b-col cols="1">
            <div class="dot_container">
              <div
                v-if="!isItemCountValid()"
                class="dot_red"
              ></div>
              <div
                v-if="isItemCountValid()"
                class="dot_green"
              ></div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="2">
            <strong>Total Weight (kg)</strong>
          </b-col>
          <b-col cols="1"
            ><b-form-input
              :ref="'txt_actual_total_weight'"
              class="center_align"
              size="sm"
              type="text"
              placeholder
              :disabled="disable_form"
              v-model="fulfil_obj.actual_total_weight"
            ></b-form-input
          ></b-col>
          <b-col cols="1">
            <div class="dot_container">
              <div v-if="!checkTotalWeight()" class="dot_red"></div>
              <div v-if="checkTotalWeight()" class="dot_green"></div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="2">
            <strong>Total Size (cm)</strong>
          </b-col>
          <b-col cols="1"
            ><b-form-input
              class="center_align"
              size="sm"
              type="text"
              placeholder="Height"
              :disabled="disable_form"
              v-model="fulfil_obj.actual_size_height"
            ></b-form-input
          ></b-col>
          <b-col cols="1"
            ><b-form-input
              class="center_align"
              size="sm"
              type="text"
              placeholder="Width"
              :disabled="disable_form"
              v-model="fulfil_obj.actual_size_width"
            ></b-form-input
          ></b-col>
          <b-col cols="1"
            ><b-form-input
              class="center_align"
              size="sm"
              type="text"
              placeholder="Depth"
              :disabled="disable_form"
              v-model="fulfil_obj.actual_size_depth"
            ></b-form-input
          ></b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            <strong>No. of Cartons</strong>
          </b-col>
          <b-col cols="1"
            ><b-form-input
              class="center_align"
              size="sm"
              type="text"
              placeholder
              :disabled="disable_form"
              v-model="fulfil_obj.no_of_cartons"
            ></b-form-input
          ></b-col>
          <b-col cols="1">
            <!-- <div class="dot_container">
              <div v-if="!checkTotalWeight()" class="dot_red"></div>
              <div v-if="checkTotalWeight()" class="dot_green"></div>
            </div> -->
          </b-col>
        </b-row>

        <b-button
          class="mt-2 btn-action btn-block"
          variant="info"
          size="lg"
          :disabled="canPrintWaybill()"
          @click="printWaybill()"
          >Print Waybill</b-button
        >
      </b-card>

      <b-modal ref="modal_confirmFulfill" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Are you sure to fulfill this order?</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_confirmFulfill"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="updateFulfillStatus()"
            >Confirm</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_takePhoto" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
                <web-cam
                    ref="webcam"
                    :device-id="deviceId"
                    width="100%"
                    @cameras="onCameras"
                    @camera-change="onCameraChange"
                />
            </b-col>

            <b-col>
                <b-select v-model="camera">
                    <option>-- Select Device --</option>
                    <option
                        v-for="device in devices"
                        :key="device.deviceId"
                        :value="device.deviceId"
                        >{{ device.label }}</option
                    >
                </b-select>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="onCancelTakePhoto()"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="onTakePhoto()"
            >Take Photo</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import printJS from "print-js";
import { WebCam } from "vue-web-cam";

const product_fields = [
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "product_qty",
    label: "Quantity"
  },
  {
    key: "product_description",
    label: "Product Description"
  }
];

export default {
  name: "OrderMasterDetail",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode,
    WebCam
  },
  data() {
    return {
      disable_form: true,
      pdf_to_print: false,
      order_master: false,
      updating_item: false,
      camera: null,
        deviceId: null,
        devices: [],
        fulfil_product_index: null,

      breadcrumb_items: [
        {
          text: "Order Master",
          to: { name: "Order Master" }
        },
        {
          text: "Detail",
          active: true
        }
      ],
      process_mode_options: [
        {
          text: "Simple",
          value: "simple"
        },
        {
          text: "Advanced",
          value: "advanced"
        }
      ],
      process_mode: "advanced",
      order_master_search: {},
      loader: false,
      order_master_products: [],
      fulfil_products: [{}],
      product_fields: product_fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      total_item_qty: 0,
      fulfil_obj: {
        total_item_qty: 0,
        total_weight: 0,
        no_of_cartons: 1,
        actual_total_weight: null,
        packed_by_vendor: null,
        actual_size_height: null,
        actual_size_width: null,
        actual_size_depth: null
      },
      tracking_obj: {},
      fulfil_orders: [
        {
          order_cartons: 1
        }
      ]
    };
  },
  async created() {

    // go to v2
    this.$router.replace('/fulfillment_process_v2');
    exit();


    // await this.getOrderMasterDetail();
    // await this.getOrderMasterProduct();
    this.initialized = true;
    if (
      this.$store.state.user_obj.client_id == "20" ||
      this.$store.state.user_obj.client_id == "23" || 
      this.$store.state.user_obj.client_id == "50"
    ) {
      this.fulfil_obj.packed_by_vendor = 1;
    }
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  watch: {
    camera: function(id) {
        this.deviceId = id;
    },
    devices: function() {
        // Once we have a list select the first one
        const [first, ...tail] = this.devices;
        if (first) {
            this.camera = first.deviceId;
            this.deviceId = first.deviceId;
        }
    }
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getFulfilmentProcessInfo() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "fulfilment_process_info_get.php",
        data: {
          tracking_number: this.order_master_search.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      if (
        !response.data.tracking.orders ||
        response.data.tracking.orders.length == 0
      ) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Invalid Tracking Number"
        });
        return;
      }

      if (response.data.tracking.status == "cancel") {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Tracking Cancelled"
        });
        return;
      }

      for (let i in response.data.tracking.orders) {
        if (
          !response.data.tracking.orders[i] ||
          response.data.tracking.orders[i].tracking_number == ""
        ) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Invalid Tracking Number"
          });
          return;
        }

        if (
          !this.fulfil_obj.packed_by_vendor &&
          response.data.tracking.orders[i].stock_status != "committed"
        ) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Stock not committed"
          });
          return;
        }

        if (response.data.tracking.orders[i].fulfilment_status == "fulfiled") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Fulfilment already completed"
          });
          return;
        }

        if (response.data.tracking.orders[i].order_import_status == "hold") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "HOLD order"
          });
          return;
        }
      }

      this.disable_form = false;

      this.tracking_obj = response.data.tracking;
      this.order_master = this.tracking_obj.orders[0];

      // console.log(this.tracking_obj);
      // console.log(this.order_master);
    },

    async getOrderMasterDetail() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_get.php",
        data: {
          tracking_number: this.order_master_search.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      if (response.data.orders && response.data.orders.length > 0) {
        let tmp_order_obj = response.data.orders[0];
        if (
          !tmp_order_obj.tracking_obj ||
          tmp_order_obj.tracking_obj.tracking_number == ""
        ) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Invalid Tracking Number"
          });
          return;
        }

        if (tmp_order_obj.stock_status != "committed") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Stock not committed"
          });
          return;
        }

        if (tmp_order_obj.fulfilment_status == "completed") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Fulfilment already completed"
          });
          return;
        }

        this.order_master = response.data.orders[0];
      }
    },

    async getOrderMasterProduct() {
      // let response = await this.$http({
      //   method: "POST",
      //   baseURL: `${this.API_HOST}`,
      //   url: "order_master_product_get.php",
      //   data: {
      //     order_number: this.order_master.order_number,
      //     account_type: this.$store.state.user_obj.account_type,
      //     client_id: this.$store.state.user_obj.client_id
      //   }
      // });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_product_get.php",
        data: {
          tracking_number: this.order_master_search.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      let total_weight = 0;
      let total_item_qty = 0;
      for (let i in response.data.products) {
        if(response.data.products[i].stock_status == 'cancel'){
          continue;
        }
        total_weight +=
          parseFloat(response.data.products[i].actual_weight_kg) *
          parseInt(response.data.products[i].product_qty);
        total_item_qty += parseInt(response.data.products[i].product_qty);
      }

      this.fulfil_obj.total_weight = total_weight;
      this.fulfil_obj.total_item_qty = total_item_qty;
      this.order_master_products = response.data.products;
    },

    async getProduct(row_product, row_product_i) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_get.php",
        data: {
          product_sku: row_product.product_sku,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      if (response.data.products && response.data.products.length > 0) {
        this.fulfil_products[row_product_i].product_description =
          response.data.products[0]["product_description_en"];
        this.fulfil_products[row_product_i].product_qty = null;
      } else {
        this.fulfil_products[row_product_i].product_description = null;
        this.fulfil_products[row_product_i].product_qty = null;
      }
    },

    async searchOrder() {
      // if (this.$store.state.user_obj.client_id == "50") {
      //   this.order_master_search.order_number = 'NEO-'+this.order_master_search.order_number;
      // }
      // await this.getOrderMasterDetail();
      await this.getFulfilmentProcessInfo();
      await this.getOrderMasterProduct();

      // focus first row
      let next_ele_ref = "txt_product_sku_0";
      if (this.fulfil_obj.packed_by_vendor) {
        next_ele_ref = "txt_order_number_0";
      }
      this.$refs[next_ele_ref][0].$el.focus();
    },

    showModal_confirmFulfill(item) {
      this.$refs.modal_confirmFulfill.show();
    },

    hideModal_confirmFulfill() {
      this.$refs.modal_confirmFulfill.hide();
    },

    async validateRowInfo(row_product, row_product_i) {
      if (this.fulfil_obj.packed_by_vendor) {
        // if (this.$store.state.user_obj.client_id == "50") {
        //   this.fulfil_orders[row_product_i].order_number = "NEO-"+this.fulfil_orders[row_product_i].order_number;
        // }
        this.lookupOrder(row_product, row_product_i);
      } else {
        if (
          this.fulfil_products[row_product_i].product_sku == null ||
          this.fulfil_products[row_product_i].product_sku == ""
        //   this.fulfil_products[row_product_i].inputType !== 'Barcode' && !this.fulfil_products[row_product_i].photo
        ) {
          return;
        }
        this.fulfil_products[row_product_i].product_sku = this.fulfil_products[row_product_i].product_sku.trim();
        // if(!isNaN(this.fulfil_products[row_product_i].product_sku)){
        if(true){
          // this.fulfil_products[row_product_i].product_sku = parseInt(this.fulfil_products[row_product_i].product_sku);
          this.fulfil_products[row_product_i].product_sku = this.fulfil_products[row_product_i].product_sku.replace(/^0+/, '');
        }

        this.lookupProduct(row_product, row_product_i);
      }
    },
    async lookupOrder(row_order, row_order_i) {
      // see if already exist first
      for (let i in this.fulfil_orders) {
        if (
          row_order_i != i &&
          this.fulfil_orders[row_order_i].order_number ==
            this.fulfil_orders[i].order_number
        ) {
          // cancel current input
          this.fulfil_orders[row_order_i].order_number = null;

          this.fulfil_orders = JSON.parse(JSON.stringify(this.fulfil_orders));

          return;
        }
      }

      // add new row if last
      if (row_order_i == this.fulfil_orders.length - 1) {
        this.fulfil_orders.push({
          order_cartons: 1
        });
      }

      // focus next row
      let next_ele_ref = "txt_order_number_" + (row_order_i + 1);
      next_ele_ref = "txt_actual_total_weight";
      // this.$refs[next_ele_ref][0].$el.focus();
      setTimeout(() => {
        this.$refs[next_ele_ref].$el.focus();
      }, 200);
    },
    async lookupProduct(row_product, row_product_i) {
      // see if already exist first
      let product_not_found = true;

      for (let i in this.fulfil_products) {
        if (
          row_product_i != i &&
          this.fulfil_products[row_product_i].product_sku ==
            this.fulfil_products[i].product_sku
        ) {
          this.fulfil_products[i].product_qty++;

          // cancel current input
          this.fulfil_products[row_product_i].product_sku = null;

          this.fulfil_products = JSON.parse(
            JSON.stringify(this.fulfil_products)
          );
          this.checkProductCnt();

          return;
        }
      }

      // lookup in product array

      for (let i in this.order_master_products) {
        let order_master_product = this.order_master_products[i];
        if (
          order_master_product.product_sku ==
          this.fulfil_products[row_product_i].product_sku
        ) {
          this.fulfil_products[row_product_i].product_description =
            order_master_product.product_description;
          this.fulfil_products[row_product_i].product_qty = 1;
          product_not_found = false;
          break;
        } else {
          // NOT FOUND, Reject IT
          // this.fulfil_products[row_product_i].product_sku = null;
          // this.fulfil_products[row_product_i].product_qty = null;
          // this.fulfil_products[row_product_i].product_description = null;
          // this.$eventHub.$emit("show_modal_message", {
          //   message_content: "Invalid Product SKU"
          // });
          // NOT FOUND, still get product info
          // await this.getProduct(row_product, row_product_i);
          // this.fulfil_products[row_product_i].product_description = null;
          // this.fulfil_products[row_product_i].product_qty = null;
        }
      }

      if (product_not_found) {
        this.fulfil_products[row_product_i].product_sku = null;
        this.fulfil_products[row_product_i].product_qty = null;
        this.fulfil_products[row_product_i].product_description = null;
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Invalid Product SKU"
        });
      }

      this.fulfil_products = JSON.parse(JSON.stringify(this.fulfil_products));

      this.checkProductCnt();

      // add new row if last
      // console.log(row_product_i);
      // console.log(this.fulfil_products.length);
      if (row_product_i == this.fulfil_products.length - 1) {
        this.fulfil_products.push({});
      }

      // focus next row
      // let next_ele_ref =
      //   "txt_product_sku_" +
      //   ((row_product_i + 1) % this.fulfil_products.length-1);
      let next_ele_ref = "txt_product_sku_" + (row_product_i + 1);
      setTimeout(() => {
        this.$refs[next_ele_ref][0].$el.focus();
      }, 200);
    },

    checkProductCnt() {
      let total_cnt = 0;
      let total_weight = 0;
      for (let i in this.fulfil_products) {
        let fulfil_product = this.fulfil_products[i];
        if (fulfil_product.product_description != null) {
          total_cnt += parseInt(fulfil_product.product_qty);
        }
      }

      this.fulfil_obj.actual_total_item_qty = total_cnt;
    },

    async updateFulfillStatus() {
      let order_master_ids = [];
      for (let i in this.tracking_obj.orders) {
        order_master_ids.push(this.tracking_obj.orders[i].id);
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfil.php",
        data: {
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          total_weight: this.fulfil_obj.actual_total_weight,
          total_height_cm: this.fulfil_obj.actual_size_height,
          total_width_cm: this.fulfil_obj.actual_size_width,
          total_depth_cm: this.fulfil_obj.actual_size_depth,
          packed_by_vendor: this.fulfil_obj.packed_by_vendor,
          total_ctns: this.fulfil_obj.no_of_cartons,
          fulfil_orders: this.fulfil_orders
        }
      });

        if (response.data.status !== "success") {
            this.$eventHub.$emit("show_modal_message", {
                message_content: response.data.error || "Fulfilment Failed",
                variant: "danger"
            });
            this.loader.hide();
            return false;
        }

      if (response.data && response.data.shopify_upload_id) {
        // await this.updateShopifyFulfilmentStatus(
        //   response.data.shopify_upload_id
        // );
      }

      this.disable_form = true;

      // await this.getOrderMasterDetail();

      let response_record = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfil_record.php",
        data: {
          tracking_number: this.tracking_obj.tracking_number,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          fulfil_products: this.fulfil_products
        }
      });
    },

    checkTotalWeight() {
      let is_valid_weight = false;
      let weight_diff =
        this.fulfil_obj.total_weight - this.fulfil_obj.actual_total_weight;

      // console.log(this.fulfil_obj.total_weight);
      // console.log(this.fulfil_obj.actual_total_weight);
      // console.log(weight_diff);

      let weight_overhead = 0.5;
      if (this.$store.state.user_obj.client_id == 1) {
        weight_overhead = 0.3;
        // if (
        //   this.fulfil_obj.actual_total_weight > 0
        // ) {
        //   is_valid_weight = true;
        // }
        if (
          this.fulfil_obj.actual_total_weight > 0 &&
          weight_diff < weight_overhead &&
          weight_diff > weight_overhead * -1
        ) {
          is_valid_weight = true;
        }
      } else {
        if (
          this.fulfil_obj.actual_total_weight > 0 &&
          weight_diff < weight_overhead &&
          weight_diff > weight_overhead * -1
        ) {
          is_valid_weight = true;
        }
      }

      return is_valid_weight;
    },

    checkProductRowSKUState(row_product) {
      if (row_product.product_sku == null) {
        return null;
      } else {
        return (
          row_product.product_description != null &&
          row_product.product_qty != null
        );
      }
    },

    checkOrderRowState(row_order, row_order_i) {
      if (row_order.order_number == null) {
        return null;
      }
      let is_valid = false;
      // lookup in order array
      for (let i in this.tracking_obj.orders) {
        let order_master_order = this.tracking_obj.orders[i];
        if (
          order_master_order.order_number ==
          this.fulfil_orders[row_order_i].order_number
        ) {
          is_valid = true;
          break;
        }
      }
      return is_valid;
    },

    checkProductRowQtyState(row_product, row_product_i) {
      if (row_product.product_sku == null || row_product.product_sku == "") {
        return null;
      } else {
        // lookup in product array
        for (let i in this.order_master_products) {
          let order_master_product = this.order_master_products[i];
          if (
            order_master_product.product_sku ==
            this.fulfil_products[row_product_i].product_sku
          ) {
            // check if qty exact match
            if (
              this.fulfil_products[row_product_i].product_qty ==
              order_master_product.product_qty
            ) {
              return true;
            }
            break;
          }
        }

        // qty not found/match
        return false;
      }
    },

    unlockQtyInput(row_product, row_product_i) {
      this.fulfil_products[row_product_i].unlock_qty = true;
    },

    canPrintWaybill() {
      if(this.disable_form){
        return true;
      }
      if (this.fulfil_obj.packed_by_vendor) {
        return false;
        // if(!this.tracking_obj){
        //   return false;
        // }
        // return (this.fulfil_orders.length == this.tracking_obj.orders.length);
      } else {
        return !(
          this.isItemCountValid() &&
          this.checkTotalWeight()
        );
      }
    },

    async updateShopifyFulfilmentStatus(shopify_upload_id) {
      let checked_items = [];

      checked_items.push(shopify_upload_id);

      this.$http({
        url: this.NODEJS_API_URL + "/shopify_order_update",
        method: "POST",
        data: {
          ids: checked_items,
          notify_customer: "yes"
        }
      }).then(response => {});
    },

    async printWaybill() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });
      let is_fulfilment_success = await this.updateFulfillStatus();
    
      if (!is_fulfilment_success) return;
      // let tracking_number = this.order_master.tracking_obj.tracking_number;
      let tracking_number = this.tracking_obj.tracking_number;
      
      // print from 3pl
      if(this.tracking_obj.three_pl_name && this.tracking_obj.three_pl_name != '' && this.tracking_obj.three_pl_name != null){
        let self = this;
        this.pdf_to_print =
          "https://tracking.gols.com.hk/3pl_file/" +
          this.tracking_obj.three_pl_name.toUpperCase() +
          "/" +
          this.tracking_obj.courier_short_name.toUpperCase() +
          "/" +
          this.tracking_obj.tracking_number +
          ".pdf";

        setTimeout(() => {
          let objFra = document.getElementById("myFrame");
          objFra.contentWindow.focus();
          objFra.contentWindow.print();
        }, 4000);

        setTimeout(() => {
          self.loader.hide();
          self.cleanupFormData();

          fetch(self.pdf_to_print).then(function(t) {
            return t.blob().then(b => {
              var a = document.createElement("a");
              a.href = URL.createObjectURL(b);
              a.setAttribute("download", self.pdf_to_print.split("/").pop());
              a.click();
            });
          });
        }, 6000);
        return;
      }

      let pdf_type = "";
      if (
        this.tracking_obj.courier_short_name.toLowerCase() == "gols" ||
        this.tracking_obj.courier_short_name.toLowerCase() == "whole"
      ) {
        let checked_items = [];
        checked_items.push(tracking_number);

        let no_of_waybill = 1;
        if (
          this.fulfil_obj.no_of_cartons &&
          this.fulfil_obj.no_of_cartons != 0
        ) {
          no_of_waybill = this.fulfil_obj.no_of_cartons;
        }

        let self = this;
        this.$http({
          url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
          method: "POST",
          data: {
            ids: checked_items,
            print_packing: false,
            print_waybill: true,
            no_of_waybill: no_of_waybill,
            print_as_file: 1,
            user_id: this.$store.state.user_obj.user_id,
          }
        }).then(response => {
          self.pdf_to_print =
            process.env.NODEJS_PDF_URL + "/" + tracking_number + ".pdf";

          setTimeout(() => {
            let objFra = document.getElementById("myFrame");
            objFra.contentWindow.focus();
            objFra.contentWindow.print();
          }, 4000);

          setTimeout(() => {
            self.loader.hide();
            self.cleanupFormData();

            fetch(self.pdf_to_print).then(function(t) {
              return t.blob().then(b => {
                var a = document.createElement("a");
                a.href = URL.createObjectURL(b);
                a.setAttribute("download", self.pdf_to_print.split("/").pop());
                a.click();
              });
            });
          }, 6000);
        });
      } else if (this.tracking_obj.courier_short_name.toLowerCase() == "7-11") {
        let checked_items = [];
        checked_items.push(tracking_number);

        let no_of_waybill = 1;
        if (
          this.fulfil_obj.no_of_cartons &&
          this.fulfil_obj.no_of_cartons != 0
        ) {
          no_of_waybill = this.fulfil_obj.no_of_cartons;
        }

        let self = this;
        this.$http({
          url: this.NODEJS_API_URL + "/redemption_waybill",
          method: "POST",
          data: {
            ids: checked_items,
            print_packing: false,
            print_waybill: true,
            no_of_waybill: no_of_waybill,
            print_as_file: 1
          }
        }).then(response => {
          self.pdf_to_print =
            process.env.NODEJS_PDF_URL + "/" + tracking_number + ".pdf";

          setTimeout(() => {
            let objFra = document.getElementById("myFrame");
            objFra.contentWindow.focus();
            objFra.contentWindow.print();
          }, 4000);

          setTimeout(() => {
            self.loader.hide();
            self.cleanupFormData();

            fetch(self.pdf_to_print).then(function(t) {
              return t.blob().then(b => {
                var a = document.createElement("a");
                a.href = URL.createObjectURL(b);
                a.setAttribute("download", self.pdf_to_print.split("/").pop());
                a.click();
              });
            });
          }, 6000);
        });
      } else if(this.tracking_obj.courier_short_name.toLowerCase() != "sf-cn"){
        let self = this;
        this.pdf_to_print =
          "https://tracking.gols.com.hk/waybill_file/" +
          this.tracking_obj.courier_short_name.toUpperCase() +
          "/" +
          this.tracking_obj.tracking_number +
          ".pdf";

        setTimeout(() => {
          let objFra = document.getElementById("myFrame");
          objFra.contentWindow.focus();
          objFra.contentWindow.print();
        }, 4000);

        setTimeout(() => {
          self.loader.hide();
          self.cleanupFormData();

          fetch(self.pdf_to_print).then(function(t) {
            return t.blob().then(b => {
              var a = document.createElement("a");
              a.href = URL.createObjectURL(b);
              a.setAttribute("download", self.pdf_to_print.split("/").pop());
              a.click();
            });
          });
        }, 6000);

        let response = await this.$http({
            method: "POST",
            baseURL: `${this.API_HOST}`,
            url: "print_waybill_log.php",
            data: {
                tracking_number: tracking_number,
                client_id: this.$store.state.user_obj.client_id,
                user_id: this.$store.state.user_obj.user_id,
            }
        });
      }
    },

    cleanupFormData() {
      this.fulfil_products = [{}];
      this.order_master_search = {};

      let current_packed_by_vendor = this.fulfil_obj.packed_by_vendor;

      // cleanup
      this.fulfil_obj = {
        total_item_qty: 0,
        total_weight: 0,
        actual_total_weight: 0,
        actual_total_item_qty: 0,
        actual_size_height: null,
        actual_size_width: null,
        actual_size_depth: null,
        no_of_cartons: 1,
        packed_by_vendor: current_packed_by_vendor
      };
      this.order_master = {};
      this.fulfil_orders = [
        {
          order_cartons: 1
        }
      ];

      this.$refs["txt_order_number"].$el.focus();
    },
    isItemCountValid() {
      if (this.fulfil_obj.total_item_qty != this.fulfil_obj.actual_total_item_qty)
          return false;

      let valid = true;
      for (const [key, value] of Object.entries(this.order_master_products)) {
          let fulfilled_product = this.fulfil_products.find(p => p.product_sku === key);
          let fulfilled_product_qty = fulfilled_product ? fulfilled_product.product_qty : -1;
          if (fulfilled_product_qty != value.committed_qty) {
              valid = false;
          }
      }

      return valid;
    },

    showModal_takePhoto(item) {
      this.$refs.modal_takePhoto.show();
    },

    hideModal_takePhoto() {
      this.$refs.modal_takePhoto.hide();
    },

    onCameras(cameras) {
        this.devices = cameras;
        console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
        this.deviceId = deviceId;
        this.camera = deviceId;
        console.log("On Camera Change Event", deviceId);
    },

    onOpenTakePhotoModal(row_index) {
        return;
        
        this.fulfil_product_index = row_index;
        let fulfil_product = this.fulfil_products[row_index];
        console.log(row_index, fulfil_product)
        if (fulfil_product.inputType == 'Keyboard') {
            this.showModal_takePhoto(fulfil_product);
            console.log(this.$refs)
            // this.$refs.webcam.start();
        }
    },
    
    onTakePhoto() {
        this.updateFulfilProduct(this.fulfil_product_index, 'photo', this.$refs.webcam.capture());
        this.hideModal_takePhoto();
    },

    onCancelTakePhoto() {
        this.hideModal_takePhoto();
        this.$refs.webcam.stop();
    },

    onKeyDown(event, index) {
        console.log(event)
        // if (event.key === 'Enter') return;
        let product = this.fulfil_products[index];
        console.log(product)
        if (!product.timeout) {
            let prev_code = product.product_sku || "";
            console.log(prev_code)
            this.updateFulfilProduct(index, 'prev_product_sku', prev_code);
            this.updateFulfilProduct(index, 'timeout', setTimeout(() => {
                let diff = product.product_sku.length - prev_code.length;
                
                if (diff >= 8) {
                    this.updateFulfilProduct(index, 'inputType', 'Barcode');
                } else {
                    this.updateFulfilProduct(index, 'inputType', 'Keyboard');
                }
                clearTimeout(this.fulfil_products[index].timeout);
                this.updateFulfilProduct(index, 'timeout', null);
            }, 100));
        }
    },
    updateFulfilProduct(index, key, value) {
        let tmp = this.fulfil_products;
        tmp[index][key] = value;
        this.fulfil_products = [...tmp];
    }
  },

};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/FulfillmentProcess.vue